<div class="popup-backdrop" (click)="PopupEvent('close')" *ngIf="popup?.Display">
</div>
<div class="popup-component" *ngIf="popup?.Display">

  <div class="popup-container patient-setup-popup">
    <div class="popup-content">
      <!-- popup header -->
      <div class="popup-header">
        <h2>{{ popup?.Title }} Checkout</h2>
      </div>
      <!-- popup body - content view -->
      <div class="popup-body" style="margin: auto;">
        <div class="popup-setup-view">
          <div class="setup-view-title">
            <div class="setup-title">
              <div class="title">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.7116 21.2142C20.0518 19.1569 18.7558 17.3623 17.0106 16.0891C15.2651 14.8159 13.1605 14.1299 11.0001 14.1299C8.83971 14.1299 6.73511 14.8159 4.98974 16.0891C3.24439 17.3623 1.94842 19.1569 1.2887 21.2142H20.7116Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11 14.1428C14.6729 14.1428 17.6504 11.1653 17.6504 7.49241C17.6504 3.81951 14.6729 0.842041 11 0.842041C7.32709 0.842041 4.34961 3.81951 4.34961 7.49241C4.34961 11.1653 7.32709 14.1428 11 14.1428Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M13.1717 10.0657C13.1717 10.0657 12.6199 11.1514 11.0002 11.1514C9.38042 11.1514 8.82861 10.0657 8.82861 10.0657" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17.5299 6.22623C17.515 6.22632 17.5002 6.22637 17.4855 6.22637C15.5523 6.22637 13.8168 5.38064 12.6286 4.03902C11.4404 5.38067 9.70486 6.22642 7.77177 6.22642C6.64923 6.22642 5.5933 5.94122 4.67249 5.43934C5.53762 2.77119 8.04347 0.842041 10.9999 0.842041C14.2398 0.842041 16.9386 3.15891 17.5299 6.22623Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Checkout Done By:</h3>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="staffList"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointmentCheckout.CheckoutAgentID"
                                     [optionsText]="'FullName'"
                                     [optionsValue]="'ID'">
                </app-custom-dropdown>
              </div>
            </div>

          </div>
          <hr />
          <div class="column gap-20">
            <div class="row">
              <div class="row gap-10">
                <label>Patient Details:</label>
                <p>{{patient.Title}} {{patient.Name}} {{patient.Surname}}</p>
              </div>
            </div>
            <div class="row gap-30 justify-space-between">
              <div class="row gap-10">
                <label>ID / Passport: </label>
                <p>{{patient.IDNumber}}</p>
              </div>
              <div class="row gap-10">
                <label>Cell Phone: </label>
                <p>{{patient.Cellphone}}</p>
              </div>
            </div>
            <hr />
            <div class="row gap-30 justify-space-between">
              <div class="row gap-10">
                <label>Service Summary:</label>
                <p>{{appointment.ServiceName}}</p>
              </div>
              <div class="row gap-10">
                <label>Duration:</label>
                <p>{{appointment.ServiceName}}</p>
              </div>
            </div>
            <div class="row gap-30 justify-space-between">
              <div class="row gap-10">
                <label>Appontment Date:</label>
                <p>{{appointment.StartDate}}</p>
              </div>
              <div class="row gap-10">
                <label>Appontment Time:</label>
                <p>{{appointment.StartTime}} - {{appointment.EndTime}}</p>
              </div>
            </div>
          </div>
          <hr />
          <div class="audiologist-details details-column" *ngIf="popup?.PopupAction == 'Audiologist'">
            <div class="details-row">
              <div class="title">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.64287 7.85714C9.61531 7.85714 11.2143 6.25816 11.2143 4.28571C11.2143 2.31327 9.61531 0.714286 7.64287 0.714286C5.67043 0.714286 4.07144 2.31327 4.07144 4.28571C4.07144 6.25816 5.67043 7.85714 7.64287 7.85714Z" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.64287 17.8571H1.21429V17.0827C1.22567 15.9939 1.51283 14.9256 2.04897 13.9778C2.58511 13.03 3.35272 12.2336 4.28011 11.6629C5.20751 11.0922 6.26442 10.7658 7.35212 10.7143C7.44909 10.7097 7.54604 10.7073 7.64287 10.7071C7.73969 10.7073 7.83665 10.7097 7.93362 10.7143C9.02132 10.7658 10.0782 11.0922 11.0056 11.6629C11.5389 11.991 12.0194 12.3939 12.4334 12.8572" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19.7857 12.1429L14.0714 19.2857L11.2143 17.1429" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Patient Status</h3>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="statusList"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="patient.Status"
                                     [optionsText]="'Description'"
                                     [optionsValue]="'Description'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="details-row">
              <div class="title">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.64287 7.85714C9.61531 7.85714 11.2143 6.25816 11.2143 4.28571C11.2143 2.31327 9.61531 0.714286 7.64287 0.714286C5.67043 0.714286 4.07144 2.31327 4.07144 4.28571C4.07144 6.25816 5.67043 7.85714 7.64287 7.85714Z" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.64287 17.8571H1.21429V17.0827C1.22567 15.9939 1.51283 14.9256 2.04897 13.9778C2.58511 13.03 3.35272 12.2336 4.28011 11.6629C5.20751 11.0922 6.26442 10.7658 7.35212 10.7143C7.44909 10.7097 7.54604 10.7073 7.64287 10.7071C7.73969 10.7073 7.83665 10.7097 7.93362 10.7143C9.02132 10.7658 10.0782 11.0922 11.0056 11.6629C11.5389 11.991 12.0194 12.3939 12.4334 12.8572" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19.7857 12.1429L14.0714 19.2857L11.2143 17.1429" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Patient Type</h3>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="patientGroups"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="patient.MemberType"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="details-row">
              <div class="title">
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.34891 5.01198C1.84197 3.60322 3.78204 0.785713 7.59774 0.785713C12.3674 0.785713 15.1048 4.83951 14.2692 8.6345C13.5447 11.9249 11.4919 13.0721 10.5863 13.8569C9.26336 15.0035 9.26373 15.939 8.78388 17.4523C8.50635 18.3277 7.54195 19.5759 6.19857 19.7298C5.22499 19.8412 4.05237 19.3779 2.7979 17.7813" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21.7143 15.3774C21.7143 18.601 19.101 21.2141 15.8775 21.2141" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19.0164 15.2673C19.0164 17.0008 17.6111 18.4061 15.8775 18.4061" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16.4063 14.3941C16.4063 15.2 15.753 15.8534 14.9471 15.8534" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4.18684 7.06459C4.47251 6.35916 5.49152 4.98189 7.28228 5.11631C9.07304 5.25073 10.6106 7.06459 9.97669 8.74761C9.34276 10.4306 8.50493 9.9096 7.74281 11.0419C6.9807 12.1741 7.26537 14.4459 5.56929 14.7851C4.51273 14.9964 3.95782 14.3901 3.95782 14.3901" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Hearing Outcome</h3>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="hearingOutcomes"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointmentCheckout.HearingOutCome"
                                     [optionsText]="'outcome'"
                                     [optionsValue]="'outcome'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="details-row">
              <div class="title">
                <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.1429 19.6429C18.1429 20.0596 17.9772 20.4594 17.6826 20.754C17.3879 21.0487 16.9882 21.2143 16.5714 21.2143H2.42858C2.0118 21.2143 1.61211 21.0487 1.3174 20.754C1.02271 20.4594 0.857147 20.0596 0.857147 19.6429V2.35714C0.857147 1.94037 1.02271 1.54067 1.3174 1.24597C1.61211 0.951274 2.0118 0.785713 2.42858 0.785713H12.6429L18.1429 6.28571V19.6429Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.8571 0.785713V7.07143H18.1429" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Final HA Outcome</h3>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="finalHAOutcomes"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointmentCheckout.FinalHAOutCome"
                                     [optionsText]="'outcome'"
                                     [optionsValue]="'outcome'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="details-row">
              <div class="title">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.92856 21.7679H13.0714" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17.7857 9.44643C17.7857 7.70357 17.1235 6.03211 15.9447 4.79972C14.7659 3.56735 13.1671 2.875 11.5 2.875C9.83292 2.875 8.23414 3.56735 7.05533 4.79972C5.87654 6.03211 5.21429 7.70357 5.21429 9.44643V15.1964C5.21429 15.85 4.96594 16.4769 4.5239 16.939C4.08186 17.4011 3.48229 17.6607 2.85715 17.6607H20.1429C19.5177 17.6607 18.9181 17.4011 18.476 16.939C18.034 16.4769 17.7857 15.85 17.7857 15.1964V9.44643Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1.28571 9.23286C1.28655 7.66909 1.64326 6.12798 2.32637 4.73681C3.00947 3.34563 3.99936 2.14434 5.21428 1.23215" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21.7143 9.23286C21.7135 7.66909 21.3568 6.12798 20.6737 4.73681C19.9906 3.34563 19.0006 2.14434 17.7857 1.23215" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Future Action</h3>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="futureActions"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointmentCheckout.FutureAction"
                                     [optionsText]="'outcome'"
                                     [optionsValue]="'outcome'">
                </app-custom-dropdown>
              </div>
            </div>
          </div>
          <div class="admin-details" *ngIf="popup?.PopupAction == 'Administration'">
            <div class="column gap-20">
              <div class="title row">
                <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.3571 0.785714H6.64284C5.77497 0.785714 5.07141 1.48927 5.07141 2.35714V3.14286C5.07141 4.01073 5.77497 4.71429 6.64284 4.71429H11.3571C12.225 4.71429 12.9286 4.01073 12.9286 3.14286V2.35714C12.9286 1.48927 12.225 0.785714 11.3571 0.785714Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M13.3214 2.35714H15.6786C16.0953 2.35714 16.4951 2.52271 16.7897 2.8174C17.0844 3.1121 17.25 3.5118 17.25 3.92857V19.6429C17.25 20.0596 17.0844 20.4594 16.7897 20.754C16.4951 21.0487 16.0953 21.2143 15.6786 21.2143H2.32143C1.90465 21.2143 1.50496 21.0487 1.21026 20.754C0.915566 20.4594 0.75 20.0596 0.75 19.6429V3.92857C0.75 3.5118 0.915566 3.1121 1.21026 2.8174C1.50496 2.52271 1.90465 2.35714 2.32143 2.35714H4.67857" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Invoice Details</h3>
              </div>
              <div class="row justify-space-between align-center">
                <label>Invoice Number</label>
                <div class="form-group">
                  <input type="text" class="input-control" [(ngModel)]="appointmentCheckout.InvoiceNumber" placeholder="Enter Invoice Number" required tabindex="4" />
                </div>

              </div>
            </div>
          </div>
          <hr />
        </div>
        <div class="popup-buttons">
          <button type="button" (click)="ButtonClick()" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.Result" (click)="AltButtonClick()" class="popup-btn">{{ popup?.AltButton?.ButtonText }}</button>
        </div>
      </div>
      

    </div>
  </div>
</div>
